export const paneIds = {
    HOME: 1,
    CREATE_WO: 2,
    GET_WO: 3,
};